import React from 'react';

const FieldGridSkeleton = ({
  titleWidth,
  fieldCount,
}: {
  titleWidth: string;
  fieldCount: number;
}) => (
  <div className="flex flex-col gap-3">
    <div className={`h-4 ${titleWidth} bg-gray-200 rounded`} />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {Array.from({ length: fieldCount }).map((_, i) => (
        <div key={i} className="flex flex-col gap-1.5">
          <div className="h-3 w-24 bg-gray-100 rounded" />
          <div className="h-9 w-full bg-gray-200 rounded-lg" />
        </div>
      ))}
    </div>
  </div>
);

// Shown while InternalFormSubmissionDetails loads — same layout (document 3/4, side column 1/4)
// and look as the credit application details page's own loading skeleton.
const InternalFormDetailsSkeleton = () => (
  <div className="w-full h-full flex flex-col lg:flex-row p-4 gap-4 animate-pulse">
    <div className="w-full lg:w-3/4 bg-white rounded-lg p-4 flex flex-col gap-4">
      <div className="flex justify-between items-center pb-2 border-b">
        <div className="flex items-center gap-2">
          <div className="h-5 w-48 bg-gray-200 rounded-md" />
          <div className="h-5 w-24 bg-gray-100 rounded-full" />
        </div>
        <div className="flex items-center gap-2">
          <div className="h-8 w-24 bg-gray-200 rounded-lg" />
          <div className="h-8 w-8 bg-gray-200 rounded-lg" />
        </div>
      </div>
      <div className="flex flex-col gap-6 mt-2">
        <FieldGridSkeleton titleWidth="w-32" fieldCount={4} />
        <FieldGridSkeleton titleWidth="w-40" fieldCount={6} />
        <FieldGridSkeleton titleWidth="w-36" fieldCount={4} />
        <div className="flex flex-col gap-3">
          <div className="h-4 w-28 bg-gray-200 rounded" />
          <div className="h-16 w-64 bg-gray-100 rounded-lg" />
        </div>
      </div>
    </div>
    <div className="w-full lg:w-1/4 flex flex-col gap-4">
      <div className="bg-white rounded-xl border border-gray-100 p-4 flex flex-col gap-3">
        <div className="h-4 w-32 bg-gray-200 rounded" />
        <div className="h-9 w-full bg-gray-200 rounded-lg" />
        <div className="grid grid-cols-2 gap-2">
          <div className="h-9 w-full bg-gray-200 rounded-lg" />
          <div className="h-9 w-full bg-gray-200 rounded-lg" />
        </div>
      </div>
      <div className="bg-white rounded-xl border border-gray-100 py-3">
        <div className="h-4 w-20 bg-gray-200 rounded mx-4 mb-2" />
        <div className="py-1 flex flex-col gap-1 px-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex items-center gap-2.5 py-2">
              <div className="w-1.5 h-1.5 rounded-full bg-gray-200 shrink-0" />
              <div className="h-3 bg-gray-200 rounded" style={{ width: `${55 + i * 8}%` }} />
            </div>
          ))}
        </div>
      </div>
      <div className="bg-white rounded-xl border border-gray-100 p-4 flex flex-col gap-3">
        <div className="h-4 w-24 bg-gray-200 rounded" />
        <div className="h-9 w-full bg-gray-200 rounded-lg" />
        <div className="h-9 w-full bg-gray-200 rounded-lg" />
      </div>
    </div>
  </div>
);

export default InternalFormDetailsSkeleton;
